import type { MouseEvent } from 'react';

type HandleCollapsedSidebarItemClickParams = {
  event: MouseEvent<HTMLElement>;
  onExpand: () => void;
};

export function handleCollapsedSidebarItemClick(params: HandleCollapsedSidebarItemClickParams): void {
  const { event, onExpand } = params;

  event.stopPropagation();
  onExpand();
}
